import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/css",
    name: "css",
    component: () => import("../views/CSS.vue"),
  },
  {
    path: "/svg",
    name: "svg",
    component: () => import("../views/SVG.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
